export const getInitialState = () => ({
  total: 0,
  totalStep1: 0,
  totalStep2: 0,
  totalStep3: 0,
  totalStep1_2: 0,
  "step2-mod01": 0,
  "step2-mod02": 0,
  "step2-mod03": 0,
  "step2-mod04": 0,
  parsedData: [],
  excelData: null,
  parsedData2: [],
  excelData2: null,
  headerParams: {},
});
